module.exports = __webpack_public_path__ + "img/tips3@x2.d1e592fe.png";